export const approvedVjalComponents = [
  "Alert",
  "AuthSurface",
  "AsyncSelect",
  "Avatar",
  "Badge",
  "Button",
  "Card",
  "Checkbox",
  "DataTable",
  "DataTableCollection",
  "DetailSurface",
  "CollectionList",
  "CollectionPagination",
  "CollectionToolbar",
  "DataTableV2",
  "FilterChips",

  "Donut",
  "EmptyState",
  "FormField",
  "FormSurface",
  "Funnel",
  "IconButton",
  "IconCalendar",
  "IconChart",
  "IconCog",
  "IconDoc",
  "IconLogout",
  "IconUsers",
  "Input",
  "Kpi",
  "Meter",
  "Modal",
  "Module",
  "ModuleBody",
  "ModuleGrid",
  "ModuleHead",
  "NavItem",
  "NavSection",
  "OtpInput",
  "PageFrame",
  "ProTable",
  "Pagination",
  "Segmented",
  "Select",
  "Sidebar",
  "Sparkbars",
  "Spinner",
  "StatTile",
  "StatusDot",
  "Switch",
  "Table",
  "Tabs",
  "Textarea",
  "Topbar",
  "TrendChart"
] as const;

export const approvedLocalCompositions = [
  "AccessState blocker presentation",
  "ActionRow",
  "CapabilityButton",
  "OperationalSurface",
  "RouteActionButton",
  "compatibility alias contract",
  "calendar focused product surface",
  "clear-series focused product surface",
  "cohort-bulk-participants focused product surface",
  "cohort-create focused product surface",
  "cohort-session-series focused product surface",
  "cohort-workspace focused product surface",
  "cohorts focused product surface",
  "companies focused product surface",
  "company-detail focused product surface",
  "dashboard focused product surface",
  "history focused product surface",
  "login focused product surface",
  "my-cohorts focused product surface",
  "participant-detail focused product surface",
  "participants focused product surface",
  "permissions focused product surface",
  "profile focused product surface",
  "program-detail focused product surface",
  "programs focused product surface",
  "org-admin-home focused product surface",
  "organizations focused product surface",
  "org-reports focused product surface",
  "report-detail focused product surface",
  "reports focused product surface",
  "resource-detail focused product surface",
  "resources focused product surface",
  "capstone focused product surface",
  "capstone-submissions focused product surface",
  "certificates focused product surface",
  "session-detail focused product surface",
  "session-invites focused product surface",
  "sessions focused product surface",
  "session-report focused product surface",
  "session-reschedule focused product surface",
  "settings focused product surface",
  "exports focused product surface",
  "tools focused product surface",
  "tool-view diagnostics sections",
  "transcript-detail focused product surface",
  "user-detail focused product surface",
  "user-edit focused product surface",
  "users focused product surface"
] as const;

export const approvedPackageGapRefs = [
  "VIL-20260608-0024",
  "csv-export-contracts",
  "super-admin-permission-management-backend"
] as const;

export const foundationShellOwners: Record<string, string> = {
  meetings: "VIL-20260608-0018",
  sessions: "VIL-20260608-0021"
};

export const screenSourceFiles: Record<string, string[]> = {
  login: ["src/pages/product-route-contracts.tsx"],
  dashboard: [
    "src/pages/product-dashboard-surface.tsx",
    "src/pages/participant-dashboard/participant-sessions-section.tsx",
    "src/pages/participant-dashboard/participant-assignments-section.tsx"
  ],
  companies: ["src/pages/companies/companies-page.tsx"],
  "company-detail": ["src/pages/companies/company-detail-page.tsx"],
  programs: ["src/pages/programs/programs-page.tsx"],
  "program-detail": ["src/pages/programs/program-detail-page.tsx"],
  cohorts: ["src/pages/cohorts/cohorts-page.tsx"],
  "my-cohorts": ["src/pages/cohorts/my-cohorts-page.tsx"],
  "cohort-create": ["src/pages/cohorts/cohorts-page.tsx"],
  "cohort-workspace": [
    "src/pages/cohorts/cohort-detail-page.tsx",
    "src/pages/cohorts/cohort-detail/cohort-participants-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-sessions-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-attendance-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-progress-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-invites-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-recordings-tab.tsx",
    "src/pages/cohorts/cohort-detail/cohort-assignments-tab.tsx"
  ],
  participants: ["src/pages/participants/participants-page.tsx"],
  "participant-detail": ["src/pages/participants/participant-detail-page.tsx"],
  "cohort-bulk-participants": [
    "src/pages/participants/bulk-import/bulk-import-page.tsx",
    "src/pages/participants/bulk-import/bulk-import-modal.tsx"
  ],
  meetings: ["src/pages/sessions/sessions-page.tsx"],
  sessions: ["src/pages/sessions/sessions-page.tsx"],
  calendar: ["src/pages/sessions/calendar-page.tsx"],
  "cohort-session-series": ["src/pages/sessions/create-series-page.tsx"],
  "clear-series": ["src/pages/sessions/clear-series-page.tsx"],
  "session-detail": ["src/pages/sessions/session-detail-page.tsx"],
  "session-invites": ["src/pages/product-session-invites-surfaces.tsx"],
  "session-reschedule": ["src/pages/product-session-reschedule-surfaces.tsx"],
  reports: [
    "src/pages/reports/reports-page.tsx",
    "src/pages/reports/reports-filter-bar.tsx",
    "src/pages/reports/reports-columns.tsx"
  ],
  "org-admin-home": ["src/pages/product-org-admin-surfaces.tsx"],
  organizations: ["src/pages/product-platform-organizations-surface.tsx"],
  "org-reports": ["src/pages/product-org-reports-surfaces.tsx"],
  "report-detail": [
    "src/pages/reports/report-detail-page.tsx",
    "src/pages/reports/report-detail/report-review-section.tsx"
  ],
  "session-report": [
    "src/pages/reports/session-report-page.tsx",
    "src/pages/reports/report-detail/report-review-section.tsx"
  ],
  "transcript-detail": ["src/pages/product-artifact-surfaces.tsx"],
  resources: [
    "src/pages/resources/resources-page.tsx",
    "src/pages/resources/resources-filter-bar.tsx",
    "src/pages/resources/resources-columns.tsx"
  ],
  "resource-detail": [
    "src/pages/resources/resource-detail-page.tsx",
    "src/pages/resources/resource-detail/resource-manage-section.tsx",
    "src/pages/resources/resource-detail/resource-download-section.tsx"
  ],
  capstone: [
    "src/pages/capstone/capstone-page.tsx",
    "src/pages/capstone/capstone-columns.tsx",
    "src/pages/capstone/capstone-submissions-section.tsx"
  ],
  "capstone-submissions": [
    "src/pages/capstone/capstone-page.tsx",
    "src/pages/capstone/capstone-columns.tsx",
    "src/pages/capstone/capstone-submissions-section.tsx"
  ],
  certificates: [
    "src/pages/certificates/certificates-page.tsx",
    "src/pages/certificates/certificates-columns.tsx",
    "src/pages/certificates/certificate-issue-section.tsx"
  ],
  history: [
    "src/pages/logs/logs-page.tsx",
    "src/pages/logs/logs-columns.tsx"
  ],
  users: ["src/pages/users/users-page.tsx"],
  "user-detail": ["src/pages/users/user-detail-page.tsx"],
  "user-edit": ["src/pages/users/user-edit-page.tsx"],
  permissions: ["src/pages/product-contract-guardrails.tsx"],
  exports: ["src/pages/exports/exports-page.tsx"],
  settings: ["src/pages/product-profile-surfaces.tsx"],
  "settings-thresholds": [
    "src/pages/settings/thresholds-page.tsx",
    "src/pages/settings/threshold-editor-row.tsx"
  ],
  tools: ["src/pages/tools/tool-view-page.tsx"],
  profile: ["src/pages/product-profile-surfaces.tsx"]
};

const screenEvidenceRoot = "docs/evidence/playwright/2026-06-07-role-pack/screens";

export const screenPackEvidenceSlugs: Record<string, string> = {
  login: "login",
  dashboard: "dashboard",
  companies: "companies-list",
  "company-detail": "company-detail",
  programs: "programs-list",
  "program-detail": "program-detail",
  cohorts: "cohorts-list",
  "my-cohorts": "my-cohorts",
  "cohort-create": "cohort-create",
  "cohort-workspace": "cohort-workspace",
  participants: "participants-list",
  "participant-detail": "participant-detail",
  "cohort-bulk-participants": "bulk-participants",
  meetings: "meetings-alias",
  sessions: "sessions-list",
  calendar: "calendar",
  "cohort-session-series": "session-series",
  "clear-series": "clear-series",
  "session-detail": "session-detail",
  "session-invites": "session-invites",
  "session-reschedule": "session-reschedule",
  reports: "reports-list",
  "org-admin-home": "org-admin-home",
  organizations: "organizations",
  "org-reports": "org-reports",
  "report-detail": "report-detail",
  "session-report": "session-report",
  "transcript-detail": "transcript-detail",
  resources: "resources-list",
  "resource-detail": "resource-detail",
  capstone: "capstone",
  "capstone-submissions": "capstone-submissions",
  certificates: "certificates",
  history: "history",
  users: "users-list",
  "user-detail": "user-detail",
  "user-edit": "user-edit",
  permissions: "permissions-backend-blocked",
  exports: "exports",
  settings: "settings",
  "settings-thresholds": "settings-thresholds",
  tools: "tool-view",
  profile: "profile"
};

export const screenEvidencePaths = evidencePathsFor("");
export const mobileEvidencePaths = evidencePathsFor("-mobile");

function evidencePathsFor(suffix: "" | "-mobile") {
  return Object.fromEntries(
    Object.entries(screenPackEvidenceSlugs).map(([routeId, slug]) => [routeId, [`${screenEvidenceRoot}/${slug}${suffix}.png`]])
  ) as Record<string, string[]>;
}
